<template>
    <div style="width: 50%;height: 620px;float: left;" ref="costAnalysis"></div>
</template>

<script>
    import request from "../http/analysis";
    const formatTime = require('./../utils/formatTime')
    export default {
        name: "costAnalysis",
        mounted() {
            this.getData() // 获取图表数据
        },
        data() {
            return {
                xAxisData: [],//横轴
                seriesData:[]//纵轴
            }
        },
        methods: {
            /*初始化饼状图*/
            initCharts() {
              //  console.log('我画图了');
                const myChart = this.$echarts.init(this.$refs.costAnalysis)
                /*图表配置*/
                let option = {
                    title:{
                        text: '成本分析表',
                        left: 'center'
                    },
                    color: ['#3398DB'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.xAxisData,
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLabel: {
                                interval: 0,
                                formatter:function(value)
                                {
                                    return value.split("").join("\n");
                                },
                                textStyle: {
                                    fontSize: 16
                                }
                            }
                            // axisLabel : {//坐标轴刻度标签的相关设置。
                            //     formatter : function(params){
                            //         var newParamsName = "";// 最终拼接成的字符串
                            //         var paramsNameNumber = params.length;// 实际标签的个数
                            //         var provideNumber = 4;// 每行能显示的字的个数
                            //         var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                            //         /**
                            //          * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                            //          */
                            //         // 条件等同于rowNumber>1
                            //         if (paramsNameNumber > provideNumber) {
                            //             /** 循环每一行,p表示行 */
                            //             for (var p = 0; p < rowNumber; p++) {
                            //                 var tempStr = "";// 表示每一次截取的字符串
                            //                 var start = p * provideNumber;// 开始截取的位置
                            //                 var end = start + provideNumber;// 结束截取的位置
                            //                 // 此处特殊处理最后一行的索引值
                            //                 if (p == rowNumber - 1) {
                            //                     // 最后一次不换行
                            //                     tempStr = params.substring(start, paramsNameNumber);
                            //                 } else {
                            //                     // 每一次拼接字符串并换行
                            //                     tempStr = params.substring(start, end) + "\n";
                            //                 }
                            //                 newParamsName += tempStr;// 最终拼成的字符串
                            //             }
                            //
                            //         } else {
                            //             // 将旧标签的值赋给新标签
                            //             newParamsName = params;
                            //         }
                            //         //将最终的字符串返回
                            //         return newParamsName
                            //     }
                            //
                            // }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    //color: '#FFFFFF',
                                    // fontSize: '38',//字体大小
                                },
                                fontSize: 17,//字体大小
                            },
                        }
                    ],
                    series: [
                        {
                            name: '直接访问',
                            type: 'bar',
                            barWidth: '60%',
                            data: this.seriesData
                        }
                    ]
                };

                /*绘制图表*/
                myChart.setOption(option)
            },
            /*获取图表数据*/
            async getData(value) {
              //  console.log(value);
                let dateObj = {
                    endDate: '',
                    startDate: ''
                }
                if(value){
                    dateObj.endDate = value[1];
                    dateObj.startDate = value[0]
                }else {
                    dateObj.endDate = formatTime(0)//当前时间
                    dateObj.startDate = formatTime(-365)//七天前
                }
               // console.log('柱状图',dateObj);
                request.getCostAnalysisData(dateObj).then(res => {
                    console.log('柱状图',res);
                    let result = res.data.data.dataListDtos
                   // console.log(result);
                    let xData = []//x轴数据
                    let yData = []//y轴数据
                    for(let i = 0; i < result.length;i++){
                        if(result[i] == null){
                            xData.push('数据为空'+ i)
                            yData.push(0)
                            continue
                        }else {
                            xData.push(result[i].name)
                            if(!result[i].value){
                                result[i].value = 0
                            }
                            yData.push(result[i].value)
                        }
                    }
                    //console.log(xData);
                    //console.log(yData);
                    this.xAxisData = xData
                    this.seriesData = yData

                    this.initCharts() // 获取数据之后再初始化图表
                })
            }
            // print(e){
            //     console.log(e)
            // }
        }
    }
</script>

<style scoped>

</style>
